import { JobStatus } from '@/models/job'

export const ACTIVE_JOB_GEOJSON_CACHE_TIME_MS = 0
export const INACTIVE_JOB_GEOJSON_CACHE_TIME_MS = 30 * 60 * 1000

export const getJobGeoJsonCacheTime = (status?: JobStatus | null) => {
  if (!status || status === JobStatus.ACTIVE) {
    return ACTIVE_JOB_GEOJSON_CACHE_TIME_MS
  }

  return INACTIVE_JOB_GEOJSON_CACHE_TIME_MS
}
